import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ isDarkMode, toggleTheme }) => {
  const { t } = useTranslation();
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    setIsAnimating(true);
    toggleTheme();
    setTimeout(() => setIsAnimating(false), 500);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      document.documentElement.classList.toggle('dark-mode', savedTheme === 'dark');
    }
  }, []);

  return (
    <button 
      className={`theme-toggle ${isAnimating ? 'animating' : ''}`} 
      onClick={handleClick}
      aria-label={isDarkMode ? t('settings.theme.lightMode') : t('settings.theme.darkMode')}
      aria-pressed={isDarkMode}
    >
      <div className="icon-container">
        <Sun className={`sun ${isDarkMode ? 'hidden' : ''}`} />
        <Moon className={`moon ${isDarkMode ? '' : 'hidden'}`} />
      </div>
    </button>
  );
};

export default ThemeToggle;
